import { IsDate, IsIn, IsNumber, IsOptional, IsString, IsUUID, Max, Min } from 'class-validator';
import { FIELD_VALUE_SOURCES, type FieldValueSource } from '../../label/field-value-source';
import { ALLERGEN_CATEGORY_KINDS, type AllergenCategoryKind } from './ingredient-allergen.dto';

export class IngredientAllergenResponseDto {
  @IsUUID()
  id!: string;

  @IsUUID()
  allergenId!: string;

  @IsOptional()
  @IsUUID()
  substanceId?: string | null;

  @IsIn(ALLERGEN_CATEGORY_KINDS)
  category!: AllergenCategoryKind;

  @IsIn(FIELD_VALUE_SOURCES)
  source!: FieldValueSource;

  @IsOptional()
  @IsUUID()
  declaredById?: string | null;

  /**
   * `null` when the caller is a tenant reading a row it does not own (the
   * promoted global catalog): naming the employee who declared this allergen
   * would leak that tenant's staff identity to every other tenant using the
   * same ingredient. See `ingredient-response.mapper.ts`.
   */
  @IsOptional()
  @IsString()
  declaredByName?: string | null;

  @IsDate()
  declaredAt!: Date;

  @IsOptional()
  @IsUUID()
  sourceDocumentId?: string | null;

  /** SO2 totale dell'ingrediente in mg/kg. `null` = non dichiarato. */
  @IsOptional()
  @IsNumber({ maxDecimalPlaces: 3 })
  @Min(0)
  @Max(100000)
  so2TotalMgPerKg?: number | null;
}
